import React from "react";
import styles from "./type-of-use-tag.module.scss";

export default function typeOfUseTag({
  type,
  text,
  className,
  width,
}: {
  type: string;
  text: string;
  className?: string;
  width?: number;
}) {
  return (
    <button
      className={`${styles.typeOfUseTag} ${styles[type]} ${className || ""}`}
      style={{width: `${width}px`}}
    >
      <span>{text}</span>
    </button>
  );
}
